import Card from "../component/Card";
import CarouselDemo from "../component/CarouselDemo";

import Menu from "../component/Menu";


function Home() {
  return (
    <>
      <CarouselDemo />
      <Card />
      <Menu />
    </>
  );
}

export default Home;
